<div
  class="tw-flex tw-items-center tw-w-full tw-h-12"
  [ngClass]="
    sunken()
      ? 'tw-rounded-xl tw-bg-color-surface-sunken ' +
        (iconLeading()
          ? 'tw-shadow-elevation-input focus-within:tw-outline focus-within:tw-outline-[1.5px] focus-within:tw-outline-[color:var(--color-intent-brand)] tw-pl-4 tw-pr-2 tw-gap-2.5'
          : 'tw-pl-6 tw-pr-3')
      : pageBg()
        ? 'tw-rounded-3xl tw-bg-color-surface-page'
        : flat()
          ? 'tw-rounded-lg tw-shadow-inner-white'
          : 'tw-rounded-lg tw-border tw-border-solid tw-border-color-border-subtle tw-shadow-elevation-input'
  "
>
  @if (sunken() && iconLeading()) {
    <icon [name]="'magnifier'" [size]="5" [currentColor]="'color-icon-secondary'"></icon>
  }
  <input
    #searchInput
    type="text"
    [placeholder]="placeholder()"
    [value]="value()"
    (input)="onInputChange($any($event.target).value)"
    class="tw-flex-1 tw-min-w-0 tw-py-2 tw-border-none focus:tw-outline-none tw-bg-transparent"
    [ngClass]="
      sunken()
        ? 'tw-text-sm tw-text-color-text-default placeholder:tw-text-color-text-tertiary'
        : pageBg()
          ? 'tw-rounded-3xl tw-px-4 placeholder:tw-text-color-text-secondary'
          : 'tw-rounded-lg tw-px-4 placeholder:tw-text-color-text-secondary'
    "
  />
  @if (clearable() && value()) {
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-size-10 tw-shrink-0 tw-text-color-icon-secondary"
      [attr.aria-label]="'pluginsClearSearch' | i18n"
      data-testid="search-clear"
      (click)="onInputChange(''); searchInput.focus()"
    >
      <icon [name]="'x-close'" [size]="4" [disableArrowOverride]="true"></icon>
    </button>
  }
  @if (!(sunken() && iconLeading())) {
    <div
      class="tw-flex tw-items-center tw-justify-center tw-shrink-0"
      [ngClass]="sunken() ? 'tw-size-10' : 'tw-pr-4'"
    >
      <icon
        [name]="'magnifier'"
        [size]="5"
        [currentColor]="sunken() ? 'color-icon-secondary' : ''"
      ></icon>
    </div>
  }
</div>
